// extracted by mini-css-extract-plugin
module.exports = {"content":"frameprice_content__2B7yo","content_title":"frameprice_content_title__26hVA"};